/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GroupServiceSearchByPartialPolicyNumberResponse
 */
export interface GroupServiceSearchByPartialPolicyNumberResponse {
    /**
     * 
     * @type {Date}
     * @memberof GroupServiceSearchByPartialPolicyNumberResponse
     */
    timePeriodDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GroupServiceSearchByPartialPolicyNumberResponse
     */
    policyNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupServiceSearchByPartialPolicyNumberResponse
     */
    groupName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GroupServiceSearchByPartialPolicyNumberResponse
     */
    originalEffectiveDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GroupServiceSearchByPartialPolicyNumberResponse
     */
    reissueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GroupServiceSearchByPartialPolicyNumberResponse
     */
    requestStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupServiceSearchByPartialPolicyNumberResponse
     */
    requestedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GroupServiceSearchByPartialPolicyNumberResponse
     */
    requestedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GroupServiceSearchByPartialPolicyNumberResponse
     */
    assignedTo?: string | null;
}

/**
 * Check if a given object implements the GroupServiceSearchByPartialPolicyNumberResponse interface.
 */
export function instanceOfGroupServiceSearchByPartialPolicyNumberResponse(value: object): value is GroupServiceSearchByPartialPolicyNumberResponse {
    return true;
}

export function GroupServiceSearchByPartialPolicyNumberResponseFromJSON(json: any): GroupServiceSearchByPartialPolicyNumberResponse {
    return GroupServiceSearchByPartialPolicyNumberResponseFromJSONTyped(json, false);
}

export function GroupServiceSearchByPartialPolicyNumberResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupServiceSearchByPartialPolicyNumberResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'timePeriodDate': json['timePeriodDate'] == null ? undefined : (new Date(json['timePeriodDate'])),
        'policyNumber': json['policyNumber'] == null ? undefined : json['policyNumber'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'originalEffectiveDate': json['originalEffectiveDate'] == null ? undefined : (new Date(json['originalEffectiveDate'])),
        'reissueDate': json['reissueDate'] == null ? undefined : (new Date(json['reissueDate'])),
        'requestStatus': json['requestStatus'] == null ? undefined : json['requestStatus'],
        'requestedBy': json['requestedBy'] == null ? undefined : json['requestedBy'],
        'requestedDate': json['requestedDate'] == null ? undefined : (new Date(json['requestedDate'])),
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
    };
}

export function GroupServiceSearchByPartialPolicyNumberResponseToJSON(json: any): GroupServiceSearchByPartialPolicyNumberResponse {
    return GroupServiceSearchByPartialPolicyNumberResponseToJSONTyped(json, false);
}

export function GroupServiceSearchByPartialPolicyNumberResponseToJSONTyped(value?: GroupServiceSearchByPartialPolicyNumberResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timePeriodDate': value['timePeriodDate'] == null ? undefined : ((value['timePeriodDate']).toISOString()),
        'policyNumber': value['policyNumber'],
        'groupName': value['groupName'],
        'originalEffectiveDate': value['originalEffectiveDate'] == null ? undefined : ((value['originalEffectiveDate']).toISOString()),
        'reissueDate': value['reissueDate'] == null ? undefined : ((value['reissueDate']).toISOString()),
        'requestStatus': value['requestStatus'],
        'requestedBy': value['requestedBy'],
        'requestedDate': value['requestedDate'] == null ? undefined : ((value['requestedDate']).toISOString()),
        'assignedTo': value['assignedTo'],
    };
}

